import { createContext, useContext } from "react";

import type { ProductRoomFormModel } from "../../../model/type";

type QueryData = ProductRoomFormModel["QueryData"];
type ViewModel = ProductRoomFormModel["ViewModel"];

export type ProductRoomFormModelContextType = {
	viewModel: ViewModel;
	onSetViewModel: <K extends keyof ViewModel>(values: { key: K; value: ViewModel[K] }[]) => void;

	queryData: QueryData;
};

export const ProductRoomFormModelContext = createContext<ProductRoomFormModelContextType | null>(null);

export const useProductRoomFormModelContext = () => {
	const context = useContext(ProductRoomFormModelContext);

	if (!context) {
		throw new Error("useProductRoomFormModelContext must be used within a ProductRoomFormModelContext.Provider");
	}

	return context;
};
